import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  confirmPulverizationActivity,
  ConfirmPulverizationActivityPayload,
} from '@/services/confirm-pulverization-activity'
import { queryClient } from '@/services/query-client'

import { GET_ACTIVITIES_QUERY } from '../queries/use-get-activities'
import { GET_PULVERIZATION_ACTIVITY_BY_ID_QUERY } from '../queries/use-get-pulverization-activity-by-id'

type UseConfirmPulverizationActivityPayload = {
  activityId: string
} & ConfirmPulverizationActivityPayload

export function useConfirmPulverizationActivity() {
  const mutation = useMutation({
    mutationFn: ({
      activityId,
      ...payload
    }: UseConfirmPulverizationActivityPayload) =>
      confirmPulverizationActivity(activityId, payload),

    onSuccess: () => {
      queryClient.invalidateQueries(GET_ACTIVITIES_QUERY)
      queryClient.invalidateQueries(GET_PULVERIZATION_ACTIVITY_BY_ID_QUERY)
    },
    onError: (error: Error) => {
      toast.error(
        `Não foi possível salvar as informações, tente novamente mais tarde. [${error?.message}]`,
      )
    },
  })

  return mutation
}
